import React from "react";
import moment from "moment";

const Deceased = ({ data, summary: isSummary, extensions: extensions }) => {
  if (isSummary) {
    if (typeof data === "boolean" && data === true) {
      return <div>Deceased</div>;
    }
    return <div>Deceased: {data && moment(data).format("L")} </div>;
  }
  const decTimeStamp = extensions
    ? extensions.filter(e => e.url.includes("deceasedTimeStamp"))
    : "";

  return (
    <>
      <div>
        <h4>Deceased</h4>
        <div>
          {typeof data === "string"
            ? moment(data).format("L")
            : typeof data === "boolean" && data
            ? "Yes"
            : "No"}
        </div>
        <div>
          <h6>
            Source Timestamp:{" "}
            {decTimeStamp[0]
              ? moment(decTimeStamp[0].valueDateTime).format("l, LTS")
              : "-"}
          </h6>
        </div>
      </div>
    </>
  );
};

export default Deceased;
